import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GenericService } from '../generic.service';
import { EnvconfigService } from '../envconfig.service';
import { ListaGeneralVistaModel } from '../../model/general/ListaGeneralVistaModel';

@Injectable({
  providedIn: 'root'
})
export class NovedadNoticiasService extends GenericService<ListaGeneralVistaModel> {

  constructor(protected override http: HttpClient,
    private enviroment: EnvconfigService) {
    super(http, `${enviroment.get("apiURL").trim()}/General`);
  }

  getNovedadNoticiaList(): Observable<any> {
    return this.http.get(this.url + '/obtener-novedad-noticia-listado');
  }

  getNovedadNoticiaActivas(): Observable<any> {
    return this.http.get(this.url + '/obtener-novedad-noticia-activas');
  }

  addNovedadNoticia(data: any): Observable<any> {
    return this.http.post(this.url + '/registrar-novedades-noticias', data);
  }

  updateNovedadNoticia(data: any): Observable<any> {
    return this.http.put(this.url + '/actualizar-novedades-noticias', data);
  }

  deleteNovedadNoticia(data: any): Observable<any> {
    return this.http.put(this.url + '/desactivar-novedades-noticias', data);    
  }
}
